import { TXStackTemplate } from "../../../types/common/templates.types";

export const X_STACK_TEMPLATE1: TXStackTemplate = {
  "Bannière Par Defaut": {
    template: [
      {
        name: "XStack",
        config: { index: "CONT" },
        props: {
          all: {},
        },
      },
    ],
  },
};
